import { render, staticRenderFns } from "./ComposerEdit.vue?vue&type=template&id=118af27a&"
import script from "./ComposerEdit.vue?vue&type=script&lang=js&"
export * from "./ComposerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118af27a')) {
      api.createRecord('118af27a', component.options)
    } else {
      api.reload('118af27a', component.options)
    }
    module.hot.accept("./ComposerEdit.vue?vue&type=template&id=118af27a&", function () {
      api.rerender('118af27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ComposerEdit.vue"
export default component.exports